import { useStore } from '@/hooks/useStore';
import { observer } from 'mobx-react-lite';
import { BookingNoteItem } from '../components/Notes';
import { ReservationNote } from '@/types/reservation';
import { useTranslation } from 'react-i18next';

interface NoteHistoryProps {
    id: string | number
}
export default observer(function NoteHistory({ id }: NoteHistoryProps) {
    // hook
    const { t } = useTranslation();

    // store
    const {
        reservationStore: { reservation }
    } = useStore();

    const { notes = [] as ReservationNote[] } = reservation || {};

    return (
        <div className='flex flex-col md:gap-5 gap-3 overflow-y-auto max-h-[75vh] pr-2'>
            {notes?.length > 0 ?
                (
                    notes.map((note, index) => (
                        <BookingNoteItem key={index} note={note} />
                    ))
                ) :
                (
                    <p className='flex items-center justify-center text-center min-h-13'>{t('sentences.no_data')}</p>
                )}

        </div>
    );
});
